import React, {useEffect} from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { URL_Route } from 'urlRouts';
import { useSelector } from 'react-redux'

interface Props{
  route:any
}

const UnProtectedRoute:React.FC<Props> = ({route}) => {
  const navigate = useNavigate();
  const islogged = useSelector((state:any) => state.userState.isLogin)
  const windowWidth = useSelector((state:any) => state.generalState.windowWidth)

  useEffect(() => {
    if (!islogged) {
      document.title = route.name
    }
  }, [navigate])
  
    return(
      <>
        {
          islogged ?
            <Navigate to={URL_Route.Panel}/>
          : 
          route.hasLayout ?
            windowWidth > 992 ?
              <route.DesktopLayout Component={<route.JsFunction Component={route.DesktopComponent}/>}/>
            : 
              <route.MobileLayout Component={<route.JsFunction Component={route.MobileComponent}/>}/>
          :
            <Navigate to={URL_Route.Login}/>
        }
      </>
    )
}

export default UnProtectedRoute;